import Spinner from "@acri-tools/react-tools/components/Spinner/Spinner";
import { axiosErrorHandler, toast_request_error } from "@acri-tools/react-tools/utils/global";
import request from "@acri-tools/react-tools/utils/request";
import React from "react";
import { ReactNode } from "react";
import store from "../redux";
import { setData } from "../redux/actions";
import { API_URL } from "./config";

// export const MISSION_COLOR_PALETTE = [
//     "#c858eb",
//     "#b33848",
//     "#7ec74e",
//     "#179ea3",
//     "#855c2d",
//     "#ff951c"
// ]
export const MISSION_COLOR_PALETTE = [
    'rgb(28, 32, 255)',
    'rgb(179, 56, 72)',
    'rgb(126, 199, 78)',
    'rgb(26, 188, 194)',
    'rgb(133, 92, 45)',
    'rgb(255, 149, 28)',
    'rgb(200, 88, 235)',
    'rgb(255, 28, 115)',

    '#85f8ea',
    '#a3a9be',
    '#eaa582',
    '#81c7e6',
    '#96fa82',
    '#fccefb',
    '#e7899a',
    '#868bea',
    '#edd0db',
    '#8680a7',
    '#ebff88',
    '#a9ac8a',
    '#80b9ce',
    '#84bda6',
    '#a2d3ff',
    '#ff82f6',
    '#ffcc80',
    '#ccff90',
    '#0277bd',
    '#8d6e63',
    '#64ffda',
    '#33691e',
    '#ec407a',
    '#ff3d00',
    '#ba68c8',
    '#81d4fa',
    '#fff700',
    '#0000ff',
    '#00ff9d',
    '#00aaff',
    '#ff6600',
    '#cdf58a',
    '#e82118',
    '#2fc747',
    '#f21d39',
    '#9e0a29',
    '#cf4789',
    '#402b4a',
    '#e39236',
    '#efc7cf',
    '#27c1ce',
    '#42347c',
    '#c16fa1',
    '#2b2731',
    '#dd7674',
    '#17df3f',
    '#72fa4c',
    '#f2dc53',
    '#720b69',
    '#725a06',
    '#1954e8',
    '#82c6f6',
    '#b65676',
    '#d6bfeb',
    '#9d79c6',
    '#e0ef50',
    '#85f8ea', '#a3a9be', '#eaa582', '#81c7e6', '#96fa82', '#fccefb', '#e7899a', '#868bea',
    '#edd0db', '#8680a7', '#ebff88', '#a9ac8a', '#80b9ce', '#84bda6', '#a2d3ff', '#ff82f6',
    '#ffcc80', '#ccff90', '#0277bd', '#8d6e63', '#64ffda', '#33691e', '#ec407a', '#ff3d00',
    '#ba68c8', '#81d4fa', '#fff700', '#0000ff', '#00ff9d', '#00aaff', '#ff6600', '#cdf58a',
    '#e82118', '#2fc747', '#f21d39', '#9e0a29', '#cf4789', '#402b4a', '#e39236', '#efc7cf',
    '#27c1ce', '#42347c', '#c16fa1', '#2b2731', '#dd7674', '#17df3f', '#72fa4c', '#f2dc53',
    '#720b69', '#725a06', '#1954e8', '#82c6f6', '#b65676', '#d6bfeb', '#9d79c6', '#e0ef50',
]

export const get_data_file_url = (file: string) => {
    return `${API_URL}/api/user-manager/v1/files/eodas_public/${file}`;
    // return `${API_URL}/data/eodas/${file}`;
}

export const format_gb_size = (value: number) => {
    if (value > Math.pow(1024, 2)) {
        return `${(value / Math.pow(1024, 2)).toFixed(2)} PB`;
    }
    if (value > 1024) {
        return `${(value / 1024).toFixed(2)} TB`;
    }
    return `${(value).toFixed(2)} GB`;
}

export const format_throughput = (value: number, options?: {
    decimals?: number,
    full?: boolean,
    base?: number
}) => {
    let prefix_value = 0;
    let base = options?.base || 1024;
    while (value > base) {
        value = value / base;
        prefix_value++;
    }
    return `${(value).toFixed(options?.decimals || 2)} Mb`;
}

export const format_bytes = (value: number, options?: {
    decimals?: number,
    full?: boolean,
    base?: number
}) => {
    let prefix_value = 0;
    let base = options?.base || 1024;
    while (value > base) {
        value = value / base;
        prefix_value++;
    }
    return `${(value).toFixed(options?.decimals || 2)} ${options?.full ? BYTE_PREFIX[prefix_value] : BYTE_PREFIX_ALT[prefix_value]}`;
}

export const format_number = (value: number, decimals: number = 2) => {
    if (value > Math.pow(1000, 3)) {
        return `${(value / Math.pow(1000, 3)).toFixed(decimals)} G`;
    }
    if (value > Math.pow(1000, 2)) {
        return `${(value / Math.pow(1000, 2)).toFixed(decimals)} M`;
    }
    if (value > 1000) {
        return `${(value / 1000).toFixed(decimals)} K`;
    }
    return `${(value).toFixed(decimals)}`;
}

export const BYTE_PREFIX_ALT = [
    "B",
    "KB",
    "MB",
    "GB",
    "TB",
    "PB",
];
export const BYTE_PREFIX = [
    "Bytes",
    "Kilo Bytes",
    "Mega Bytes",
    "Giga Bytes",
    "Tera Bytes",
    "Peta Bytes",
];
export const BYTE_PREFIX_I_ALT = [
    "iB",
    "KiB",
    "MiB",
    "GiB",
    "TiB",
    "PiB",
];

// export const VOLUME_SUFFIXES = [
//     'Bytes', 'KiloBytes', 'MegaBytes', 'GigaBytes', 'TeraBytes', 'PetaBytes'
// ]

export const PREFIX = [
    "",
    "Thousand",
    "Million",
    "Billion"
]


export const get_text_counter = (name: ReactNode, value?: string, loading?: boolean) => {
    let value_split = value?.split(' ');
    return {
        name,
        unit: value_split?.[1] || undefined,
        value: loading ? <Spinner height={14} />
            : value_split?.[0] || <div className="no-data">NO DATA</div>,
    }
}
export const get_global_stats_counter = (name: string, unit?: string, value?: number, loading?: boolean) => {
    return {
        name,
        unit: value ? unit : undefined,
        value: loading ? <Spinner height={14} />
            : value || <div className="no-data">NO DATA</div>,
    }
}

export const fetch_global_data = async () => {

    store.dispatch(setData({ loading_global_stats: true }));
    try {
        let res = await request(get_data_file_url(`global_stats.json`), { method: 'get' })

        store.dispatch(setData({ global_stats_data: res.data }));
        // this.setState({ counter_data: res.data });
    }
    catch (e) {
        axiosErrorHandler(e, { functionName: `fetch_global_data` });
        toast_request_error(e);
    }
    finally {
        store.dispatch(setData({ loading_global_stats: false }));
    }
}